import { eventChannel } from 'redux-saga'
import { put, take } from 'redux-saga/effects'
import { openModal } from './actions'

function createModalEventChannel() {
  return eventChannel(emit => {
    const listener = e => {
      emit(e.detail)
    }

    document.addEventListener('@mati:modal-open', listener)

    return () => {
      document.removeEventListener('@mati:modal-open', listener)
    }
  })
}

function * modalEventSaga() {
  const channel = createModalEventChannel()

  try {
    while (true) {
      const { modalType, id, name, ...rest } = yield take(channel)
      yield put(openModal(modalType, { id, name, ...rest }))
    }
  } finally {
    channel.close()
  }
}

export default function * saga() {
  yield modalEventSaga()
}
